module.exports = __webpack_public_path__ + "img/verification.aae2472b.png";